export const dynamicallyResizeShopifyImageUrl = (src: string, imageSize: string): string => {
  if (!src) return '';
  if (!src.includes('cdn.shopify')) return src;

  const size = imageSize ?? ((window?.innerWidth ?? 1011) > 1010 ? '240x240' : '160x160');

  return src
    .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|[0-9]+x[0-9]+|master)+\./g, '.')
    .replace(/\.jpg|\.pjpg|\.png|\.gif|\.jpeg/g, function (match) {
      return `_${size}${match}`;
    });
};

// eslint-disable-next-line import/no-default-export
export default dynamicallyResizeShopifyImageUrl;
